<template>
  <div
    id="fmCloud"
    class="fmCloud"
    @mousemove="selectItems"
    @contextmenu.prevent="showMenu($event)"
  >
    <div class="fixed-top" :style="`width:${$store.state.appRightWidth}px`">
      <TabList
        ref="tabList"
        curId="0"
        :disabled="has_any_data == 0 && params.keyword == '' ? 1 : 0"
        :placeholder="$t('shortChain.stext2')"
        @searchList="searchList"
      ></TabList>
    </div>
    <div class="fc-content" id="fc-content">
      <div class="fc-second" @mouseenter="handleMouseenter($event, -1, -100)">
        <div class="add-box">
          <div
            class="btn-add"
            @mouseleave="isFmAddHove = false"
            @mouseenter="isFmAddHove = true"
          >
            <fm-button
              class="fm-button-in"
              icon="icon-cloud-add"
              round
              @click="addShort(1)"
              >{{ $t('shortChain.newShortLink') }}</fm-button
            >
            <div class="lineTips"></div>
            <div class="addMenu" :class="isFmAddHove ? 'addMenuHover' : ''">
              <span @click="addShort(1)">{{
                $t('shortChain.newShortLink')
              }}</span>
              <span @click="addShort(2)">{{
                $t('shortChain.bulkCreate')
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="file-type">
        <div class="search-result" v-if="params.keyword !== ''">
          <el-tooltip
            class="item r-tooltip"
            effect="dark"
            :content="$t('shortChain.allLinks')"
            placement="top"
          >
            <span class="all" @click="resetRouter">{{
              $t('shortChain.allLinks')
            }}</span>
          </el-tooltip>
          <div class="r-search">
            <svg-btn icon-class="icon-file-direction" />
            <div class="r-search-tit">
              {{ $utils.searchTitSlice(params.keyword) }}
            </div>
          </div>
        </div>
        <div
          class="search-result"
          @mouseenter="handleMouseenter($event, -1, 0)"
          v-else
        >
          <el-tooltip
            class="item r-tooltip"
            effect="dark"
            :content="$t('shortChain.allLinks')"
            placement="top"
          >
            <span class="all" @click="resetRouter">{{
              $t('shortChain.allLinks')
            }}</span>
          </el-tooltip>
          <div class="total">
            {{ total }}
          </div>
        </div>
        <div class="fileClass">
          <div class="multiple-operation" v-if="checkedFiles.length > 0">
            <div
              v-if="!isHasLockFile()"
              @click="rightHandle(1, checkidsAllInfo[0])"
            >
              <svg-btn icon-class="icon-short-copy"></svg-btn>
              <span>{{ $t('shortChain.CopyLink') }}</span>
            </div>
            <div @click="deleteShort(2)">
              <svg-btn icon-class="icon-multiple-delete" />
              <span>{{ $t('shortChain.Delete') }}</span>
            </div>
          </div>
          <div :class="{ screenBt: true, screenBtNone: has_any_data == 0 }">
            <svg-btn class="screen" icon-class="icon-cloud-screen" />
            <div class="floatBox">
              <div class="title">添加筛选条件</div>
              <div class="content">
                <div class="box" @click="chageRebate('')">
                  <svg-btn
                    class="icon_checks"
                    :icon-class="
                      params.rebate_model == ''
                        ? 'icon-file-check'
                        : 'icon-file-uncheck-' + $store.state.theme
                    "
                  ></svg-btn>
                  <span>全部</span>
                </div>
                <div
                  v-for="item in rebateList"
                  @click="chageRebate(item.id)"
                  :key="item.id"
                  class="box"
                >
                  <svg-btn
                    class="icon_checks"
                    :icon-class="
                      item.id == params.rebate_model
                        ? 'icon-file-check'
                        : 'icon-file-uncheck-' + $store.state.theme
                    "
                  ></svg-btn>
                  <span>{{ $t(item.name) }}</span>
                </div>
              </div>
            </div>
            <!-- 为了适配悬浮而创建的子类 -->
            <div class="lineTips"></div>
          </div>
          <div
            :class="{ screenBt: true, screenBtNone: has_any_data == 0 }"
            style="margin-right: 4px"
          >
            <svg-btn class="screen" icon-class="icon-option" />
            <div class="screenBox">
              <div
                @click="changeSort(item.id)"
                v-for="item in screenList"
                :key="item.id"
                :class="{
                  curScreen: item.id == screenId,
                }"
              >
                <svg-btn icon-class="icon-cloud-check" />
                <span>{{ item.name }}</span>
              </div>
            </div>
            <!-- 为了适配悬浮而创建的子类 -->
            <div class="lineTips"></div>
          </div>
          <span class="line"></span>
          <fm-button
            class="icon-refresh"
            @click="refresh"
            icon="icon-refresh"
            type="info"
            text
            size="small"
          ></fm-button>
        </div>
      </div>
      <!-- 列表 -->
      <div
        v-loading="loading"
        class="file-content-box"
        @mousedown="handleMouseDown($event, -1)"
        @dragenter.prevent
        @dragover.prevent
      >
        <div
          v-show="total != 0"
          class="tab-th"
          @dragenter.prevent="setDragIndex"
          style="padding-right: 28px"
        >
          <div class="selectAll">
            <div @click="allCheck == 2 ? cancelCheckedVal() : setCheckedVal()">
              <svg-btn
                class="icon_checks"
                :icon-class="
                  allCheck == 2
                    ? 'icon-file-check'
                    : allCheck == 0
                    ? 'icon-file-uncheck-' + $store.state.theme
                    : 'icon-file-checks'
                "
              >
              </svg-btn>
            </div>
            <span style="min-width: 114px">{{ $t('shortChain.title') }}</span>
          </div>
          <div class="lineup6" style="margin-right: 34px">
            <span>{{ $t('shortChain.TargetURL') }}</span>
          </div>
          <div class="lineup7" style="margin-left: 10px">
            <span>{{ $t('shortChain.ViewsRedirects') }}</span>
          </div>
          <div class="lineup2" style="margin-left: 10px">
            <span>{{ $t('shortChain.revenueModel') }}</span>
          </div>
          <div
            class="lineup3"
            @click="changeSort(params.edit_time == 0 ? 1 : 0)"
          >
            <span>{{ $t('shortChain.editTime') }}</span>
            <img
              :src="
                params.edit_time == 1
                  ? $utils.getPng('web4/icon_order_descending')
                  : $utils.getPng('web4/icon_order_ascending')
              "
            />
          </div>
        </div>
        <div class="file-list" v-show="shortList.length > 0">
          <QVirtualList
            ref="virtualBox"
            :items="shortList"
            :item-size="virtualDom.itemSize"
            :is-over="isOver"
            id="qVirtualDom"
            class="file-virtual-list"
            key-field="id"
            @onEnd="getFiles"
            @onScroll="scrollBoxFun"
            @dragleave.native.prevent="listDragleave"
            @getVlBoxAttr="onGetVlBoxAttr"
          >
            <template v-slot:default="{ item, index }">
              <div
                :key="item.id"
                :id="'upload-' + item.id"
                :class="{
                  hoverItem: item.isHover || checkedFiles.indexOf(index) > -1,
                  'active-1': dragoverIndex === index,
                  inFirst: dragoverIndex === index && virtualDom.inFirst === 1,
                  'file-item-hover-1':
                    $store.state.showFlag == 2 && item.is_file == 0,
                }"
                class="file-item-hover"
                @mousedown="handleMouseDown($event, index)"
                @mouseenter="handleMouseenter($event, index)"
                @mouseleave="handleMouseleave($event, index)"
                @dblclick="item.locked_status == 0 ? open(item) : ''"
              >
                <a-dropdown :trigger="dropdown" @visibleChange="visibleChange">
                  <div
                    class="file-item cursorbtn"
                    :class="{ lockeditem: item.locked_status == '1' }"
                  >
                    <div></div>
                    <!-- 加了一个div是为了阻止chooseFile单击事件触发了双击事件 -->
                    <div class="icon_checks_wrap" @dblclick.stop>
                      <svg-btn
                        class="icon_checks"
                        @click.prevent="chooseFile(index)"
                        :icon-class="
                          checkedFiles.indexOf(index) > -1
                            ? 'icon-file-check'
                            : 'icon-file-uncheck-' + $store.state.theme
                        "
                      ></svg-btn>
                    </div>
                    <div class="lineup1">
                      <div class="openFoldername">
                        <div class="file_icon">
                          <img class="icon" :src="item.web_icon" />
                        </div>
                        <el-tooltip
                          :disabled="tooltipDisabled"
                          open-delay="1000"
                          popper-class="item list-tooltip"
                          effect="dark"
                          :content="item.url_title"
                          placement="bottom"
                        >
                          <span
                            class="name"
                            @mouseleave="tooltipDisabled = true"
                            @mouseenter="tooltipDisabled = false"
                            >{{ item.url_title }}</span
                          >
                        </el-tooltip>
                        <div
                          class="locked-info"
                          v-show="item.locked_status == '1'"
                        >
                          <svg-btn icon-class="icon-tips-warning" />
                          <span>已锁定</span>
                        </div>
                      </div>
                    </div>
                    <div class="lineup66">
                      <el-tooltip
                        open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        :content="item.jump_url"
                        placement="bottom"
                      >
                        <span
                          :class="{
                            lineup78:
                              item.isHover ||
                              checkedFiles.indexOf(index) > -1 ||
                              hoverIndex === index,
                          }"
                          >{{ item.jump_url }}</span
                        >
                      </el-tooltip>
                    </div>
                    <div
                      class="tools-box"
                      v-if="
                        item.isHover ||
                        checkedFiles.indexOf(index) > -1 ||
                        hoverIndex === index
                      "
                    >
                      <div
                        class="itemFilesTools"
                        @dblclick.stop
                        v-show="checkedFiles.length < 2"
                      >
                        <template v-if="item.locked_status == '0'">
                          <div class="act" @click="open(item)">
                            <el-tooltip
                              open-delay="1000"
                              popper-class="item list-tooltip"
                              effect="dark"
                              content="查看"
                              placement="bottom"
                            >
                              <svg-btn
                                icon-class="icon-view"
                                iconColor="iconColor2"
                              ></svg-btn>
                            </el-tooltip>
                          </div>
                          <div
                            class="act"
                            @click.stop="copyUrl(item.share_url)"
                          >
                            <el-tooltip
                              open-delay="1000"
                              popper-class="item list-tooltip"
                              effect="dark"
                              content="复制短链"
                              placement="bottom"
                            >
                              <svg-btn
                                icon-class="icon-share2"
                                iconColor="iconColor2"
                              ></svg-btn>
                            </el-tooltip>
                          </div>
                          <div class="act" @click.stop="openShort(item, 2)">
                            <el-tooltip
                              open-delay="1000"
                              popper-class="item list-tooltip"
                              effect="dark"
                              content="查看分享"
                              placement="bottom"
                            >
                              <svg-btn
                                icon-class="icon-cloud-share"
                                iconColor="iconColor2"
                              ></svg-btn>
                            </el-tooltip>
                          </div>
                          <div class="act" @click.stop="openShort(item, 3)">
                            <el-tooltip
                              open-delay="1000"
                              popper-class="item list-tooltip"
                              effect="dark"
                              content="编辑"
                              placement="bottom"
                            >
                              <svg-btn
                                icon-class="icon-share"
                                iconColor="iconColor2"
                              ></svg-btn>
                            </el-tooltip>
                          </div>
                          <div class="act">
                            <el-dropdown
                              @visible-change="changeVisible($event, item)"
                              @command="command => handleCommand(command, item)"
                              placement="bottom-start"
                            >
                              <div>
                                <svg-btn
                                  icon-class="icon-cloud-more"
                                  iconColor="iconColor2"
                                ></svg-btn>
                              </div>
                              <el-dropdown-menu
                                class="moreAct"
                                slot="dropdown"
                                :class="isOpen ? '' : 'isOpen1'"
                              >
                                <el-dropdown-item command="a"
                                  ><span>{{
                                    $t('cloud.rightDelete')
                                  }}</span></el-dropdown-item
                                >
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                        </template>
                        <template v-else>
                          <div class="act" @click="handleCommand('a', item)">
                            <el-tooltip
                              open-delay="1000"
                              popper-class="item list-tooltip"
                              effect="dark"
                              content="删除"
                              placement="bottom"
                            >
                              <svg-btn
                                icon-class="icon-multiple-delete"
                              ></svg-btn>
                            </el-tooltip>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div style="width: 52px" v-else></div>
                    <div class="lineup7">
                      {{ item.view_volume }}/{{ item.jump_volume }}
                    </div>
                    <div class="lineup2">{{ item.rebate_model_label }}</div>
                    <div class="lineup3">{{ item.edit_time }}</div>
                  </div>
                  <template #overlay>
                    <a-menu
                      class="menu-a"
                      @contextmenu.prevent
                      :class="isOpen2 ? 'menu-b' : ''"
                      v-if="isOpen"
                    >
                      <a-menu-item
                        @click="rightHandle(menu_item.id, item)"
                        v-for="menu_item in isHasLockFile()
                          ? list3
                          : isSelectMore
                          ? list2
                          : list1"
                        :key="menu_item.id"
                        :class="menu_item.id == -1 ? 'line' : 'me-item'"
                        >{{ $t(menu_item.name) }}
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </div>
            </template>

            <template v-slot:noMore>
              <div
                class="isOver"
                v-if="loadNextPage"
                v-loading="loadNextPage"
              ></div>
              <div class="isOver" v-if="isOver && showEnd">
                {{ $t('cloud.noMore') }}
              </div>
            </template>
          </QVirtualList>
          <div
            v-show="showFlag == 1"
            class="selection-box"
            :style="{
              left: selectionBox.left + 'px',
              top: selectionBox.top + 'px',
              width: selectionBox.width + 'px',
              height: selectionBox.height + 'px',
            }"
          ></div>
        </div>
        <!-- 缺省空状态 -->
        <div
          class="addShotChainBox"
          v-show="!loading && has_any_data == 0 && params.keyword == ''"
        >
          <div class="Boxone">
            <img :src="$utils.getPng('icon-short-one-new')" class="iconOne" />
            <span class="font1">{{ $t('shortChain.stext3') }}</span>
            <span class="font2">{{ $t('shortChain.stext4') }}</span>
            <fm-button class="oneBt" round @click="addShort(1)">{{
              $t('shortChain.createShortLink')
            }}</fm-button>
          </div>
          <div class="Boxtwo">
            <img :src="$utils.getPng('icon-short-two')" class="iconTwo" />
            <div class="fontBox">
              <div class="fontBoxOne">
                <span class="font3">{{
                  $t('shortChain.createShortLinkTwo')
                }}</span>
                <span class="font3">{{ $t('shortChain.stext5') }}</span>
              </div>
              <div class="fontBoxOne">
                <span class="font3">{{ $t('shortChain.shareShortLink') }}</span>
                <span class="font3">{{ $t('shortChain.stext6') }}</span>
              </div>
              <div class="fontBoxOne">
                <span class="font3">{{ $t('shortChain.earnMore') }}</span>
                <span class="font3">{{ $t('shortChain.stext7') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="file-default"
          v-show="!loading && shortList.length == 0 && params.keyword != ''"
        >
          <img :src="$utils.getPng('web4/file_default')" />
          <div class="search">
            <span>{{ $t('shortChain.noResultsFound') }}</span>
            <span>{{ $t('shortChain.tryAnotherKeyword') }}</span>
          </div>
        </div>
        <div
          class="file-default"
          v-show="!loading && shortList.length == 0 && params.keyword == ''"
        >
          <img :src="$utils.getPng('web4/file_default')" />
          <div class="search">
            <span>{{ $t('shortChain.stext8') }}</span>
            <span>{{ $t('shortChain.stext9') }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 绑定手机1  实名认证2 验证码3-->
    <BindPhone
      :isShow="isShowBindPhone"
      :type="bindType"
      :time="time"
      @getPhoneCode="getPhoneCode"
      @bindPhone="bindPhone"
      @confirmNameAuth="realNameAuth"
      @handleClose="closeBindPhone"
    ></BindPhone>
    <!-- 自定义右键菜单 -->
    <CustomContextMenu
      ref="customMenu"
      :visible="showContextMenu"
      :x="menuPosition.x"
      :y="menuPosition.y"
      :selected-item="selectedItem"
      @action="handleMenuAction"
      @close="closeMenu"
    />
    <!-- 分享短链 -->
    <ShareShortLink
      :isShow="showLink"
      :isType="isType"
      :status="status"
      :zcfshort="zcfshort"
      :rebateList="rebateList"
      :white_list="white_list"
      @refresh="refresh"
      @upRebate="upRebate"
      @handleClose="closeLink"
    ></ShareShortLink>
    <!-- 查看复制短链 -->
    <ViewLink
      :batchUrl="batchUrl"
      :isShow="showView"
      @handleClose="showView = false"
    ></ViewLink>
    <!-- 删除提示框 -->
    <TitleDialog
      :is-show="iShow"
      :text="text"
      @handleClose="onClose"
      @handleConfirm="onConfirm"
    >
    </TitleDialog>
    <div class="toTop-div" v-show="showTop" @click="scrollToTop">
      <svg-btn
        icon-class="icon-toTop"
        style="width: 24px; height: 24px"
      ></svg-btn>
    </div>
  </div>
</template>

<script>
import TabList from './TabList/index.vue'
import BindPhone from '@/components/Cloud/BindPhone'
import QVirtualList from '@/components/QVirtualList/qVirtualList.vue'
import { shortList, shortModel, delShort } from '@/utils/apiList/short'
import {
  bindPhoneSendCode,
  bindPhoneAPI,
  realNameAuth,
} from '@/utils/apiList/account'
import CustomContextMenu from '@/components/CustomContextMenu/index.vue'
import ShareShortLink from '@/components/ShareShortLink/index'
import ViewLink from '@/components/ShareShortLink/viewLink.vue'
import TitleDialog from '@/components/Dialog/TitleDialog.vue'
export default {
  components: {
    BindPhone,
    TabList,
    QVirtualList,
    CustomContextMenu,
    ShareShortLink,
    TitleDialog,
    ViewLink,
  },
  data() {
    return {
      curId: 0,
      screenList: [{ id: 1, name: '按时间排序' }],
      screenId: 1,
      shortList: [], //短链列表
      total: 0, //总条数 缺省判断
      has_any_data: 0, //判断有没有值
      checkedFiles: [], //选中文件
      allCheck: 0,
      isShowBaseDialog: false,
      isFmAddHove: false,
      isShowBindPhone: false,
      loading: true,
      loadNextPage: false,
      handleItem: {}, //当前操作项
      params: {
        page: 0,
        limit: 60,
        keyword: '',
        edit_time: 1, //编辑时间排序 大小排序1倒叙，0升序 默认1
        rebate_model: '', //返利模式  1-免登录无条件跳转 2-登录后无条件跳转 3-去小程序看广告后跳转 4-去APP看广告后跳转
      },
      dragoverIndex: -1,
      showTop: false,
      isOver: false,
      showEnd: true,
      bindType: 1, //
      msgid: '', //验证码id
      timerA: null,
      time: 60,
      isSelecting: 0,
      startX: 0,
      startY: 0,
      selectionBox: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      },
      moveBox: {
        left: 0,
        top: 0,
      },
      showFlag: 0,
      trage_ids: '',
      trage_move_ids: '',
      trage_folder_id: -1,
      isOpen: false,
      isOpen2: true,
      list1: [
        { id: 0, name: 'shortChain.View' },
        { id: -1, name: '' },
        { id: 1, name: 'shortChain.CopyLink' },
        { id: 2, name: 'shortChain.Share' },
        { id: 3, name: 'shortChain.Edit' },
        { id: -1, name: '' },
        { id: 4, name: 'shortChain.Delete' },
      ],
      list2: [
        { id: 1, name: 'shortChain.CopyLink' },
        { id: -1, name: '' },
        { id: 4, name: 'shortChain.Delete' },
      ],
      list3: [{ id: 4, name: 'shortChain.Delete' }],
      isSelectMore: false,
      uploaderPosition: '',
      dropdown: ['contextmenu'],
      phone_item: {
        phone: '',
        pcode: '',
        sms_type: 0,
      },
      virtualDom: {
        inFirst: 0,
        itemSize: 56,
        offsetTop: 0,
        start: 0,
        count: 0,
      },
      tooltipDisabled: false,
      sc: '', //屏幕点击位置
      ms: '', //屏幕点击位置
      icon: '',
      checkids: [],
      checkidsAllInfo: [],
      hoverIndex: '', //判断鼠标移入了哪个index
      showContextMenu: false,
      menuPosition: { x: 0, y: 0 },
      selectedItem: [
        {
          id: 2,
          name: 'cloud.Refresh',
        },
      ],
      showLink: false,
      isType: 1, //1是单个新建 2是批量新建
      status: 0, //2是查看 3是编辑
      zcfshort: '',
      rebateList: [], //分享模式list
      white_list: '', //支持域名
      iShow: false,
      text: '确定删除该短链，删除后将无法找回',
      fshort: '',
      showView: false,
    }
  },
  created() {
    let appRightWidth = document.getElementById('app-bottom-right')?.clientWidth

    this.$store.commit('setAttr', {
      name: 'appRightWidth',
      val: appRightWidth,
    })
    //获取收益模式列表
    this.getShortModel()
    this.getFiles(1)
  },
  watch: {
    checkedFiles: {
      handler(newval, oldVal) {
        if (newval.length > 0 && newval.length < this.shortList.length) {
          this.allCheck = 1
        } else if (newval.length == 0) {
          this.allCheck = 0
        } else if (newval.length == this.shortList.length) {
          this.allCheck = 2
        }
        var ids = []
        var urls = []
        var checkidsAllInfo = []
        newval.map(item => {
          ids.push(this.shortList[item].fshort)
          urls.push(this.shortList[item].share_url)
          checkidsAllInfo.push(this.shortList[item])
        })
        this.checkids = ids
        this.checkidsAllInfo = checkidsAllInfo
      },
      immediate: true,
    },
    pageValue(newVal) {
      if (newVal == 1) {
        this.cancelCheckedVal()
        this.scrollToTop()
      }
    },
  },
  computed: {
    pageValue() {
      return this.params.page
    },
  },
  mounted() {
    this.$store.commit('setAttr', {
      name: 'endSelectFuncallback',
      val: this.endSelectFun,
    })
  },
  methods: {
    addShort(num) {
      if (this.$store.state.userInfo.phone == '') {
        this.bindType = 1
        this.isShowBindPhone = true
        return
      }
      this.isType = num
      this.showLink = true
    },
    //关闭短链弹窗
    closeLink() {
      this.showLink = false
      this.status = 0
      this.zcfshort = ''
      setTimeout(() => {
        this.isType = 1
      }, 200)
    },
    //获取模式
    getShortModel() {
      shortModel()
        .then(res => {
          if (res.status == 1) {
            this.rebateList = res.data.config
            if(res.data.white_list.length > 0){
              this.white_list = res.data.white_list.join('、') + '；'
            }
          }
        })
        .catch(err => {})
    },
    upRebate(arr) {
      this.rebateList = arr
    },
    showMenu(event) {
      event.preventDefault() // 阻止默认行为
      event.stopPropagation() // 阻止事件冒泡
      const forbiddenSelectors = [
        '.file-item-hover',
        '.ant-dropdown',
        '.ant-dropdown-menu',
        '.ant-menu',
      ]
      const isForbidden = event.target.closest(forbiddenSelectors.join(','))
      if (isForbidden) {
        this.closeMenu()
        return
      }
      this.cancelCheckedVal()
      // 获取菜单的实际尺寸
      const menuSize = this.$refs.customMenu.getMenuSize()
      const menuWidth = menuSize.width
      const menuHeight = menuSize.height

      // 获取视口尺寸
      const viewportWidth = document.documentElement.clientWidth
      const viewportHeight = document.documentElement.clientHeight

      // 动态调整菜单位置
      let x = event.clientX
      let y = event.clientY - 50

      // 判断是否靠近窗口右侧
      if (x + menuWidth > viewportWidth) {
        x = event.clientX - menuWidth
      }
      // 判断是否靠近窗口底部
      if (y + menuHeight > viewportHeight - 150) {
        y = event.clientY - 135
      }
      // 设置菜单位置
      this.menuPosition = {
        x: x,
        y: y,
      }

      // 显示菜单
      this.showContextMenu = true
    },
    closeMenu() {
      this.showContextMenu = false
    },
    handleMenuAction(action) {
      switch (action) {
        case 2:
          this.refresh()
          break
      }
    },
    onGetVlBoxAttr(args) {
      let dom = args.vlBox
      this.virtualDom.start = args.start
      this.virtualDom.count = args.vlCount
      this.virtualDom.offsetTop = dom.offsetTop
      if (dom.offsetParent) {
        this.virtualDom.offsetTop += dom.offsetParent.offsetTop
      }
      let appView = document.getElementById('app-view')
      if (appView) {
        this.virtualDom.offsetTop += appView.offsetTop
      }
    },
    isHasLockFile() {
      let arr = this.checkedFiles.map(item => {
        return this.shortList[item]
      })
      return arr?.some(item => item.locked_status == '1')
    },
    //切换筛选
    chageRebate(id) {
      this.params.rebate_model = id
      this.checkedFiles = []
      this.getFiles(1)
    },
    //切换排序
    changeSort(id) {
      this.params.edit_time = id
      this.checkedFiles = []
      this.getFiles(1)
    },
    //刷新
    refresh() {
      this.params.page = 0
      this.checkedFiles = []
      this.getFiles(1)
    },
    //搜索
    searchList(value) {
      this.params.keyword = value
      this.checkedFiles = []
      this.getFiles(1)
    },
    scrollBoxFun(e) {
      this.showTop = e.sTop > 50
      this.showEnd = e.distance <= 136
      this.virtualDom.start = e.start
      this.virtualDom.count = e.vlCount
      let list = document.getElementsByClassName('el-tooltip__popper')
      let list1 = document.getElementsByClassName('el-dropdown-menu')
      if (list.length > 0) {
        list[list.length - 1].style.display = 'none'
      }
      if (list1.length > 0) {
        list1[list1.length - 1].style.display = 'none'
      }
      //滚动关闭右键菜单
      if (this.showContextMenu) {
        this.showContextMenu = false
      }
    },
    scrollToTop() {
      this.$refs.virtualBox?.scrollToTop()
    },
    //打开短链
    open(row) {
      window.open(row.share_url, '_blank')
    },
    //复制短链
    copyUrl(url) {
      this.$copyText(url).then(
        e => {
          this.$toast('复制短链成功', 1)
        },
        function (e) {}
      )
    },
    //获取列表
    getFiles: _.debounce(
      function (type = 0) {
        if (type == 1) {
          this.loading = true
          this.params.page = 0
        } else {
          if (this.isOver) {
            return
          }
          this.loadNextPage = true
        }
        this.params.page += 1
        this.isOver = false
        shortList(this.params)
          .then(res => {
            if (res.status == '1') {
              this.loading = false
              this.loadNextPage = false
              this.total = parseInt(res.data.total)
              this.has_any_data = res.data.has_any_data
              if (res.data.list.length < this.params.limit) this.isOver = true
              res.data.list.forEach(item => {
                item.isHover = false
              })
              if (this.params.page == 1) {
                this.shortList = res.data.list || []
              } else {
                this.shortList = this.shortList
                  .concat(res.data.list)
                  .filter(
                    (item, index, self) =>
                      index == self.findIndex(t => t.fshort == item.fshort)
                  )
              }
              if (
                this.checkedFiles.length > 0 &&
                this.checkedFiles.length < this.shortList.length
              ) {
                this.allCheck = 1
              } else if (this.checkedFiles.length == 0) {
                this.allCheck = 0
              } else if (this.checkedFiles.length == this.shortList.length) {
                this.allCheck = 2
              }
            } else {
              this.loading = false
              this.$toast(res.msg, 2)
            }
            if (this.params.page == 1) {
              this.$nextTick(() => {
                this.scrollToTop()
              })
            }
          })
          .catch(err => {})
      },
      50,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    // 重置查询
    resetRouter() {
      this.params = {
        page: 1,
        limit: 60,
        keyword: '',
        edit_time: 1,
        rebate_model: '',
      }
      this.checkedFiles = []
      this.$refs.tabList.keyword = ''
      this.getFiles(1)
    },

    // 单个点击选中
    chooseFile(index) {
      // 点击文件选中
      var exist = this.checkedFiles.indexOf(index)
      if (exist == -1) {
        this.checkedFiles.push(index)
      } else {
        this.checkedFiles.splice(exist, 1)
      }
    },
    // 全选
    setCheckedVal() {
      // 点击文件选中
      this.checkedFiles = []
      var tmpfiles = this.shortList
      for (var i = 0, len = tmpfiles.length; i < len; i++) {
        this.checkedFiles.push(i)
      }
      this.allCheck = 1
    },
    // 取消全选
    cancelCheckedVal() {
      this.allCheck = 0
      this.checkedFiles = []
    },
    //下拉框出现/隐藏时触发
    changeVisible(e, item) {
      item.isHover = e
    },
    //更多操作 a删除
    handleCommand: _.debounce(
      function (command, item) {
        this.handleItem = item
        if (command == 'a') {
          this.deleteShort(1)
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //右键操作
    rightHandle(id, item) {
      this.visibleChange(false)
      switch (id) {
        case 0:
          this.open(item)
          break
        case 1:
          let url
          // 批量复制
          if (this.checkedFiles.length > 1) {
            this.batchUrl = this.checkidsAllInfo
            this.showView = true
            return
          } else {
            url = item.share_url
          }
          // 单个复制
          this.copyUrl(url)
          break
        case 2:
          this.openShort(item, 2)
          break
        case 3:
          this.openShort(item, 3)
          break
        case 4:
          this.deleteShort(this.checkedFiles.length > 0 ? 2 : 1)
          break
        default:
          break
      }
    },
    onClose() {
      this.fshort = ''
      this.iShow = false
    },
    //删除短链事件
    onConfirm: _.debounce(
      function () {
        delShort({ fshort: this.fshort })
          .then(res => {
            if (res.status == 1) {
              this.onClose()
              this.refresh()
              this.$toast('所选短链已删除', 1)
            } else {
              this.$toast(res.msg, 2)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //多选、单选删除
    deleteShort(num) {
      //1单选删除 2多选删除
      if (num == 1) {
        this.fshort = this.handleItem.fshort
      } else if (num == 2) {
        this.fshort = this.checkids.join(',')
      }
      if (this.checkedFiles.length > 1) {
        this.text = `确定删除所选 ${this.checkedFiles.length} 项短链，删除后将无法找回`
      } else {
        this.text = '确定删除该短链，删除后将无法找回'
      }
      this.iShow = true
    },
    //分享
    openShort(row, num) {
      this.status = num
      this.zcfshort = row.fshort
      this.showLink = true
    },
    getPhoneAly(captcha_verify, validate = {}) {
      return new Promise(resolve => {
        if (validate == 'close') {
          return
        }
        bindPhoneSendCode({
          phone: this.phone_item.phone,
          pcode: this.phone_item.pcode,
          sms_type: this.phone_item.sms_type,
          captcha_verify: captcha_verify || '',
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
        }).then(res => {
          if (res.status == '1') {
            resolve({
              result: true,
              validate: true,
            })
            this.$toast(res.msg, 1)
            this.msgid = res.data.msgid
            this.bindType = 3
            this.timerA = setInterval(() => {
              this.minute()
            }, 1000)
          } else if (res.status == 90001) {
            resolve({
              result: false,
              validate: false,
            })
            this.$toast(res.msg, 2)
            this.$AliCode.handleOpen(this.getPhoneAly)
          } else if (res.status == 90002) {
            this.$utils.initgt4(
              '5b0562a75492b420626b745b229e83a4',
              this.getPhoneAly
            )
          } else {
            resolve({
              result: true,
              validate: true,
            })
            this.$toast(res.msg, 2)
          }
        })
      })
    },
    //发送验证码
    getPhoneCode(phone, pcode, sms_type) {
      this.phone_item = {
        phone,
        pcode,
        sms_type,
      }
      // var reg_tel =
      //   /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // if (!reg_tel.test(phone)) {
      //   this.$toast("请正确输入手机号", 3);
      //   return true;
      // }
      this.getPhoneAly()
    },
    closeBindPhone() {
      this.time = 60
      this.timerA && clearInterval(this.timerA)
      this.isShowBindPhone = false
    },
    minute() {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        clearInterval(this.timerA)
      }
    },
    bindPhone(data) {
      let params = { msgid: this.msgid, ...data }
      bindPhoneAPI(params).then(res => {
        if (res.status == '1') {
          this.isShowBindPhone = false
          this.$store.commit('getuserVuex')
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    realNameAuth(data) {
      realNameAuth(data).then(res => {
        if (res.status == '1') {
          this.isShowBindPhone = false
          this.$store.commit('getuserVuex')
          this.$toast(res.msg, 1)
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
    handleMouseDown: _.debounce(
      function (event, index) {
        this.selectionBox = {
          left: 0,
          top: 0,
          width: 0,
          height: 0,
        }
        this.startX = event.clientX
        this.startY = event.clientY

        const currentX = event.clientX
        const currentY = event.clientY
        this.moveBox = {
          left: 0,
          top: 0,
        }
        // 检查触发事件的元素是否是 file-item-hover 的父元素
        if (event.button == 0) {
          let arr = [
            'icon',
            'name',
            'icon_checks',
            'el-image__inner',
            'iconColor',
          ]
          if (!arr.includes(event.target.classList[0])) {
            //点击icon_checks 即左侧选中多选不触发handleMouseDown 只触发chooseFile
            // 执行你的 mousedown 逻辑
            this.selectItemOne(index)
            this.moveBox = {
              left: currentX,
              top: currentY - 56,
            }
          }
          this.isOpen = false
        } else if (event.button == 1) {
        } else if (event.button == 2) {
          var exist = this.checkedFiles.indexOf(index)
          if (exist == -1) {
            this.checkedFiles = []
            index != -1 ? this.checkedFiles.push(index) : ''
          } else {
          }
          if (this.checkedFiles.length > 1) {
            this.isSelectMore = true
          } else {
            this.isSelectMore = false
          }
        }
      },
      100,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleMouseenter(event, index, id = -100) {
      this.hoverIndex = index
      this.trage_folder_id = -1
      if (this.isSelecting != 2) return
      let arr = this.shortList.filter(
        (item, index1) => index1 == index && item.is_file == 0
      )
      if (id != -100) {
        this.trage_folder_id = id
      } else {
        this.trage_folder_id = arr.length > 0 ? arr[0].id : '-1'
      }
    },
    handleMouseleave(event, index) {
      this.hoverIndex = ''
    },
    selectItemOne(index) {
      // 点击文件选中
      if (index == -1) {
        this.isSelecting = 1
        return
      }
      var exist = this.checkedFiles.indexOf(index)
      if (exist == -1) {
        this.checkedFiles = []
        this.checkedFiles.push(index)
        this.isSelecting = 1
      } else {
        this.isSelecting = 2
        // this.checkedFiles.splice(exist, 1);
      }
    },
    selectItems: _.debounce(
      function (event) {
        const currentX = event.clientX
        const currentY = event.clientY
        if (this.isSelecting == 2) {
          this.moveBox = {
            left: currentX,
            top: currentY - 56,
          }
          let file_arr = []
          let folder_arr = []
          let chooseOne = this.shortList[this.checkedFiles[0]]

          let str = `${chooseOne.name}${chooseOne.extension || ''}`

          let obj = {
            icon:
              chooseOne.is_file == '0'
                ? chooseOne.ext_icon
                : chooseOne.showPlay
                ? chooseOne.ext_icon
                : this.$utils.fileIcon(chooseOne.extension),
            name: str,
            count: this.checkedFiles.length,
          }
          this.$store.commit('setAttr', {
            name: 'check_str',
            val: obj,
          })

          this.checkedFiles.map(item => {
            if (this.shortList[item].is_file == '1') {
              file_arr.push(this.shortList[item].id)
            } else {
              folder_arr.push(this.shortList[item].id)
            }
          })
          this.trage_ids = file_arr.toString()
          this.trage_move_ids = folder_arr.toString()
          this.showFlag = 2
          this.$store.commit('setAttr', {
            name: 'showFlag',
            val: 2,
          })
        } else if (this.isSelecting == 1) {
          this.showFlag = 1
          this.$store.commit('setAttr', {
            name: 'showFlag',
            val: 1,
          })
          // 计算选择框的位置和大小
          const minX = Math.min(this.startX, currentX)
          const minY = Math.min(this.startY, currentY)
          const maxX = Math.max(this.startX, currentX)
          const maxY = Math.max(this.startY, currentY)
          this.selectionBox = {
            left: minX,
            top: minY - 56,
            width: maxX - minX,
            height: maxY - minY,
          }
          // 遍历可选择项，判断是否在选择框内并选中
          let checkedList = []
          let _start = this.virtualDom.start
          const itemElement =
            this.$refs.virtualBox.$el.querySelectorAll('.file-item-hover')
          if (itemElement && itemElement.length > 0) {
            for (let i = 0; i < itemElement.length; i++) {
              let _index = _start + i
              const itemRect = itemElement[i].getBoundingClientRect()
              if (itemRect.top > minY - 56 && itemRect.bottom < maxY + 39) {
                if (!checkedList.includes(_index)) {
                  checkedList.push(_index)
                }
              } else {
                const index = checkedList.indexOf(_index)
                if (index !== -1) {
                  checkedList.splice(index, 1)
                }
              }
            }
            this.checkedFiles = checkedList
          }
        }
      },
      0,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    endSelectFun() {
      setTimeout(() => {
        this.isSelecting = 0
        this.showFlag = 0
        this.$store.commit('setAttr', {
          name: 'showFlag',
          val: 0,
        })
        this.$store.commit('setAttr', {
          name: 'check_str',
          val: '',
        })
      }, 0)
    },
    listDragleave(e) {
      if (
        e.target.id === 'qVirtualDom' ||
        (e.x === 0 && e.y === 0) ||
        e.offsetX <= 0
      ) {
        this.dragoverIndex = -1
      }
    },
    setDragIndex() {
      this.dragoverIndex = -1
    },
    visibleChange(e) {
      if (e) {
        this.dropdown = ['contextmenu', 'click']
        this.isOpen = e
        this.isOpen2 = true
      } else {
        this.isOpen2 = false
        this.dropdown = ['contextmenu']
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
